document.addEventListener("DOMContentLoaded", function () {
  document.body.addEventListener('click', function (event) {
    if (event.target && event.target.id === 'readmore') {
      const description = event.target.previousElementSibling;
      if (event.target.classList.contains('opened')) {
        description.style.maxHeight = '90px';
        event.target.textContent = 'Read More';
        event.target.classList.remove('opened');
      } else {
        description.style.maxHeight = 'max-content';
        event.target.textContent = 'Read Less';
        event.target.classList.add('opened');
      }
    }
  });
});